export { TermsAndConditions } from './TermsAndConditions';
